export const SUPERVISI = [
  {
    title: 'Intens',
    value: 'INTENSE',
  },
  {
    title: 'Minimal',
    value: 'MINIMAL',
  },
  {
    title: 'Sedang',
    value: 'MODERATE',
  },
  {
    title: 'Otonom',
    value: 'AUTONOMOUS',
  },
];

export const GLOBAL_RATING = [
  {
    title: 'Perlu Perbaikan',
    value: 'NEED_REMEDIAL',
  },
  {
    title: 'Baik',
    value: 'ADEQUATE',
  },
  {
    title: 'Cukup',
    value: 'GOOD',
  },
  {
    title: 'Sangat Baik',
    value: 'VERY_GOOD',
  },
];

export const KESULITAN = [
  {
    title: 'Mudah',
    value: 'EASY',
  },
  {
    title: 'Intermediet',
    value: 'INTERMEDIATE',
  },
  {
    title: 'Sulit',
    value: 'HARD',
  },
];
